import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex flex-col mb-6 md:items-end md:justify-between md:flex-row" }
const _hoisted_3 = { class: "flex flex-col mt-6 space-y-3 md:items-center md:space-x-3 md:space-y-0 md:flex-row md:mt-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Add Record", -1)
const _hoisted_6 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "w-6 h-6 bg-[#D2851B] rounded-full object-cover text-center mr-2"
}
const _hoisted_9 = { class: "text-white text-[0.625rem] font-bold leading-6" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_14 = {
  key: 0,
  class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap"
}
const _hoisted_15 = {
  key: 1,
  class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap"
}
const _hoisted_16 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_17 = {
  key: 2,
  class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap"
}
const _hoisted_18 = {
  key: 3,
  class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap"
}
const _hoisted_19 = { class: "block px-6 py-6 space-y-3 text-sm text-gray-900" }
const _hoisted_20 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "pl-1 text-white" }, " View Patient Summary", -1)
const _hoisted_22 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "pl-1 text-white" }, " View Patient Details ", -1)
const _hoisted_24 = { class: "w-full px-6 border-t py-7" }

import { ref, computed, watch } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import DataTable from "@/components/partials/DataTable.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import { PlusIcon } from "@heroicons/vue/24/outline";
import { useRouter, useRoute } from "vue-router";
import PatientService from "@/classes/PatientService";
import pickBy from "lodash/pickBy";
import Storage from "@/helpers/storage";
import PageLoader from "@/components/loaders/PageLoader.vue";
import { hasPermission } from "@/classes/AuthService";
import { useNetworkStore } from "@/store/network";
import DateFormatter from "@/helpers/DateFormatter"; 
import { onIonViewWillEnter } from "@ionic/vue";
import SearchIcon from "@/components/icons/searchIcon.vue"; 
import PatientRecordService from "@/classes/Patients/PatientRecordService";

interface itemsInterface {
	id: number;
	last_name: string;
	first_name: string;
	middle_name: string;
	nickname: string;
	birthdate: string;
	created_at_formatted: string;
	abbr: string;
	gender_meta: object;
}
 

export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const router = useRouter();
const route = useRoute();
const storage = new Storage();

/**
 * VARIABLES
 */
const items = ref<itemsInterface[]>([]);
const page = ref<string | null>(route.query.page);
const lastPage = ref<number | null>(null);
const rows = ref<number | null>(route.query.rows || 5);
const numRows = computed<string | null>(() => (rows.value ? rows.value + " Rows" : "All"));
const lastName = ref<string | null>(route.query.last_name);
const birthdate = ref<string | null>(route.query.birthdate);
const firstName = ref<string | null>(route.query.first_name);
const loading = ref<boolean>(false);
const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "First Name" },
	{ text: "Last Name" },
	{ text: "Sex" },
	{ text: "Birthday" },
	{ text: "Primary Diagnosis" },
	{ text: "Date Registered", haveSort: false },
];

const getData = async () => {
	loading.value = true;

    // Call this service when network is online or offline
    const response = await PatientRecordService.search({
        last_name: lastName.value,
        first_name: firstName.value,
        birthdate: birthdate.value,
        page: page.value,
        rows: rows.value,
    }, isNetworkAvailable.value);

    if (response?.response?.status === 404) {
        loading.value = false;
        return;
    }
    
    if (response?.status === 200 || response?.data != undefined) {
        storage.set(
            "search",
            JSON.stringify({
                last_name: lastName.value,
                first_name: firstName.value,
                birthdate: birthdate.value,
            })
        );
        page.value = response.data.items.current_page;
        lastPage.value = response.data.items.last_page;
         
        items.value = response.data.items.data;
        
        loading.value = false;
    } else {
        const error = response;
        loading.value = false;
        console.log(error);
    }
};

const reloadPage = async () => {
	return await router.push({
		path: "/patient/index",
		query: pickBy({
			last_name: lastName.value,
			first_name: firstName.value,
			birthdate: birthdate.value,
			page: page.value,
			rows: rows.value,
		}),
	});
};

const applyFilters = async () => {
    await reloadPage();
    await getData();
};

const paginate = async (data: number): void => {
	page.value = data;
	await applyFilters();
};

const changeRows = async (row: any): void => {
	rows.value = row;
	await applyFilters();
};

const getSearchFromStorage = async (): void => {
	const searchData = await JSON.parse(storage.get("search"));
	lastName.value = searchData ? searchData.last_name : lastName.value;
	firstName.value = searchData ? searchData.first_name : firstName.value;
	birthdate.value = searchData ? searchData.birthdate : birthdate.value;
};

watch(
    () => isNetworkAvailable.value,
    () => {
        loading.value = false;
        getData();
    }
);

onIonViewWillEnter(async () => {
    await getSearchFromStorage();
    await applyFilters();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Patient",
            description: "View the data analytics in the system."
          }),
          _createElementVNode("div", _hoisted_3, [
            (_unref(hasPermission)('can-search-patients'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/patient/search')))
                }, [
                  _createVNode(ButtonComponent, { customClass: "quaternary md:w-auto w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(SearchIcon, { class: "object-contain w-4 h-4 mr-1 -ml-2 icon" }),
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(hasPermission)('can-create-patient-information'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).replace('/patient/create')))
                }, [
                  _createVNode(ButtonComponent, { customClass: "primary md:w-auto w-full" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(DataTable, {
            headers: headers,
            "no-action": false,
            count: items.value?.length,
            tableClass: "header-frm-table two three four five"
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (item?.patient?.abbr)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.patient?.abbr), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "object-cover w-6 h-6 mr-2 text-center rounded-full",
                            src: item?.patient?.profile_photo_url || item.profile_photo_url
                          }, null, 8, _hoisted_10)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item?.patient?.first_name || item.first_name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item?.patient?.last_name || item.last_name), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item?.patient?.gender || item.gender), 1),
                  (item?.patient?.birthdate)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(item?.patient?.birthdate ? _unref(DateFormatter).customDateFormat(item?.patient?.birthdate, 'MM/dd/yyy') : item?.patient?.computed_age), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(item?.birthdate ? _unref(DateFormatter).customDateFormat(item?.birthdate, 'MM/dd/yyy') : item.computed_age), 1)),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.primary_diagnosis || item.primary_diagnoses), 1),
                  (item?.patient?.registered_at)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(_unref(DateFormatter).customDateFormat(item?.patient?.registered_at, 'MM/dd/yyy - hh:mm:ss')), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_unref(DateFormatter).customDateFormat(item.registered_at, 'MM/dd/yyy - hh:mm:ss')), 1)),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_unref(hasPermission)('can-view-patients-information'))
                        ? (_openBlock(), _createBlock(ViewButton, {
                            key: 0,
                            class: "min-w-[130px]",
                            "custom-class": "flex items-center justify-center w-full",
                            onClick: ($event: any) => (
												// router.replace(
												// 	`/patient/${item.patient_id ? item.patient_id : item.offlineData?.offline_id}/view${
												// 		item.id ? '' : '?offline=true'
												// 	}`
												// )
                                                _unref(router).replace(`/patient/${item.patient_id}/view`)
											)
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (_unref(hasPermission)('can-view-patients-information'))
                        ? (_openBlock(), _createBlock(ViewButton, {
                            key: 0,
                            class: "min-w-[130px]",
                            "custom-class": "flex items-center justify-center w-full",
                            onClick: ($event: any) => (
												// router.replace(
												// 	`/patient/${item.patient_id ? item.patient_id : item.offlineData?.offline_id}/cases/${item.id}/edit`
												// )
                                                _unref(router).replace(`/patient/${item.patient_id}/cases/${item.id}/edit`)
											)
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            tfoot: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(MinifyPagination, {
                  numRows: numRows.value,
                  "onUpdate:rows": _cache[2] || (_cache[2] = (value) => changeRows(value)),
                  "onUpdate:page": _cache[3] || (_cache[3] = (value) => paginate(value)),
                  "current-page": page.value,
                  "last-page": lastPage.value
                }, null, 8, ["numRows", "current-page", "last-page"])
              ])
            ]),
            _: 1
          }, 8, ["count"])
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})